import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, UntypedFormBuilder, UntypedFormGroup, Validators, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { ButtonConfig, ModalService } from '@collab/comp-library';
import { PasswordValidator, MinMaxValidator } from 'src/app/shared/component/validators/patternValidator';
import { passwordResetErrors } from 'src/app/shared/constants/form-error.constants';
import { AuthenticationService } from '../login/service/authentication.service';
import { ModalConfig } from '@collab/comp-library/ui/modal/modal.config';
import { LoginComponent } from '../login/login.component';

@Component({
  selector: 'app-password-reset-page',
  templateUrl: './password-reset-page.component.html',
  styleUrls: ['./password-reset-page.component.scss']
})
export class PasswordResetPageComponent implements OnInit {
  @Output() newPasswordChanged: EventEmitter<boolean> =
    new EventEmitter<boolean>();
    public loginComponet!: LoginComponent;
    public passwordResetForm!: FormGroup;
    public passwordResetErrors = passwordResetErrors;
    public isOldPasswordTextType = true;
    public isNewPasswordTextType = true;
    public isConfirmPasswordTextType = true;
    public visible = "assets/icons/visible.svg";
    public invisible = "assets/icons/invisible.svg";
    public errors: string[] = [];
    public isEmpty: boolean = false;
    public isFormSubmitted = false;
    public minMaxRegex = /^.{8,20}$/;
    public passwordRegex =/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,20}$/;
    public loginButtonConfig: ButtonConfig = {
      text: 'Set Password',
      buttonType: 'primary',
      iconURL: '',
      imageUrl: '',
      linkURL: ''
  };
  public passwordConfirmModal: ModalConfig = {
    id: "password-confirm",
    type: "alert",
    title: "New Password",
    closeButton: true,
    primaryButtonConfig: {
      text: "Ok",
      buttonType: "primary",
      buttonSize: "medium",
      imageUrl: "",
      linkURL: "",
    },
  };

    constructor(private formBuilder: FormBuilder,private authenticationService: AuthenticationService,private router: Router,private modalService: ModalService  ) {}

    ngOnInit(): void {
        this.passwordResetForm = this.createForm();
    }

    /**
     *
     * this method will create a login form
     * @return {*}  {FormGroup}
     * @memberof LoginComponent
     */
    public createForm(): UntypedFormGroup {
        return this.formBuilder.group({
            oldPassword: [ null, [Validators.required],MinMaxValidator(this.minMaxRegex) ],
            newPassword: [ null, [Validators.required, MinMaxValidator(this.minMaxRegex), PasswordValidator(this.passwordRegex)] ],
            confirmPassword: [ null, [Validators.required, MinMaxValidator(this.minMaxRegex), PasswordValidator(this.passwordRegex)] ]
        });
    }

      public closeModal() {
        this.modalService.close("password-confirm");
        this.authenticationService.setNewPasswordState(false);
      }
    public resetPassword(): void {
        this.isFormSubmitted = true;
        this.errors = [];

        let formValues = this.passwordResetForm.getRawValue();

        if (!formValues.oldPassword || !formValues.newPassword || !formValues.confirmPassword) {
            this.isEmpty = true;
        }

        if (formValues.oldPassword === formValues.newPassword) {
            this.errors.push('New password should not be same as old password');
        }

        if (formValues.newPassword !== formValues.confirmPassword) {
            this.errors.push('New password should match with confirm password');
        }

        if (this.passwordResetForm.get('newPassword')!.hasError('pattern') || 
            this.passwordResetForm.get('confirmPassword')!.hasError('pattern')) {
            this.errors.push('The password should meet the criteria')
        }

        if (formValues.oldPassword && formValues.newPassword && formValues.confirmPassword && formValues.oldPassword !== formValues.newPassword
            && formValues.newPassword === formValues.confirmPassword) {
            this.authenticationService.passwordReset(formValues).subscribe((_res) => {
            this.modalService.open("password-confirm");
    })
            }
    this.isEmpty = true;
  }

    get newPassword() {
        return this.passwordResetForm?.get('newPassword');
    }

    public convertToFormControl(absCtrl: AbstractControl | null): FormControl {
        const ctrl = absCtrl as FormControl;
        return ctrl;
  }
  public ngOnDestroy(): void {
    this.modalService.remove("password-confirm");
  }
}
